

import React from "react";
import { DesignerIntroComponent, HalfPageTextComponent, IntroComponent, ProjectIntroComponent, SideBySideTextComponent, TitleComponent } from '../contents/index';
import SpacerComponent from '../contents/spacer';
import DealerList from '../dealer-list/dealer-list.component';
import DesignerList from '../designer-list/designer-list.component';
import ProjectDesignerList from '../designer-list/project-designer-list.component';
import { Container } from '../grid/grid.component';
import HeroComponent from '../hero/hero.component';
import MediaFullWidth from '../media/fullwidth.component';
import ProductGrid from '../product.grid/product.grid';
import ProductSpecs from '../product.specs/product.specs.component';
import Watercolor from '../watercolor/watercolor';

const Modules = ({ __typename, data, alldata, transitionStatus }) => {

  switch (__typename) {
    case 'PrismicProductBodyIntro': return <IntroComponent {...{ text: data.primary.text.text }} />;
    case 'PrismicPageBodyTitle': return <TitleComponent {...{ title: data.primary.title1.text, intro: data.primary.intro, alignment: data.primary.alignment }} />;
    case 'PrismicPageBodyHero': return <HeroComponent {...{ title: data.primary.hero_title, image: data.primary.image }} />;
    case 'PrismicProductBodyMediafullwidth': return <MediaFullWidth images={data.items} />;
    case 'PrismicCasesBodyMedia': return <Container><MediaFullWidth images={data.items} /></Container>;
    case 'PrismicPageBodyMedia': return <Container><MediaFullWidth images={data.items} /></Container>;
    case 'PrismicPageBodySpacer': return <SpacerComponent {...data} />;
    case 'PrismicProductBodySpacer': return <SpacerComponent {...data} />;
    case 'PrismicCasesBodySpacer': return <SpacerComponent {...data} />;
    case 'PrismicProductBodySpecs': return <ProductSpecs {...{ width: alldata.width, depth: alldata.depth, height: alldata.height, materialscount: alldata.materialscount, materials: alldata.materials, colorscount: alldata.colorscount, colors: alldata.colors, technical_drawing_horizontal: alldata.technical_drawing_horizontal.localFile.childImageSharp, technical_drawing_vertical: alldata.technical_drawing_vertical.localFile.childImageSharp }} />;
    case 'PrismicPageBodyProductList': return <Container><ProductGrid {...data} transitionStatus={transitionStatus} /></Container>;
    case 'PrismicPageBodyDesignersList': return <DesignerList {...data} />;
    case 'PrismicPageBodyDealerList': return <DealerList {...data} />;
    case 'PrismicCasesBodyTextTwoColumns': return <Container><SideBySideTextComponent {...{ items: data.items, stack: data.primary.mobile_stack }} /></Container>;
    case 'PrismicPageBodyTextTwoColumns': return <Container><SideBySideTextComponent {...{ items: data.items, stack: data.primary.mobile_stack }} /></Container>;
    case 'PrismicPageBodyHalfPageText': return <Container><HalfPageTextComponent {...{ html: data.primary.text.html }} /></Container>;
    case 'PrismicCasesBodyWatercolor': return <Watercolor {...{ image: data.primary.watercolor_image.url }} />;
    case 'PrismicProductBodyProjectIntro': return <ProjectIntroComponent {...data} />;
    case 'PrismicProductBodyDesignerIntro': return <ProjectDesignerList designers={alldata.by.document} />;//<DesignerIntroComponent {...alldata.by.document} />;
    default: console.log(__typename); return '';
  }
}

export default Modules;

